document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quick-view-btn").forEach(button => {
    button.addEventListener("click", function () {
      const handle = this.dataset.handle;
      fetch(`/products/${handle}?view=quickview`)
        .then(res => res.text())
        .then(html => {
          document.getElementById("quick-view-content-inner").innerHTML = html;
          document.getElementById("quick-view-popup").style.display = "flex";

          const minus = document.querySelector(".qty-minus");
          const plus = document.querySelector(".qty-plus");
          const input = document.querySelector(".qty-input");
          const finalQty = document.querySelector(".final-qty");

          minus.addEventListener("click", () => {
            if (parseInt(input.value) > 1) input.value--;
            finalQty.value = input.value;
          });
          plus.addEventListener("click", () => {
            input.value++;
            finalQty.value = input.value;
          });
          input.addEventListener("change", () => {
            if (parseInt(input.value) < 1) input.value = 1;
            finalQty.value = input.value;
          });
        });
    });
  });

  document.querySelector(".quick-view-close").addEventListener("click", () => {
    document.getElementById("quick-view-popup").style.display = "none";
  });
});
